import { useMemo } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { getStoredUser } from '../utils/auth';
import SlabInventory from './inventory/SlabInventory';
import { createInventoryApi } from './inventory/inventoryApi.mjs';

// Navigation is only a convenience. Every endpoint independently verifies access.
const OWNERS = new Set(['randolph@pokerand.net', 'andrew.shane@pokerand.net']);

export default function BusinessSlabInventory() {
  const [params] = useSearchParams();
  const requestedUse = ['randys_pc','investment','shopify','grandium','set_chase','auction','unassigned'].includes(params.get('use')) ? params.get('use') : 'all';
  const user = getStoredUser();
  const email = String(user?.email || '').trim().toLowerCase();
  const api = useMemo(() => createInventoryApi({
    getAccessToken: () => {
      const current = getStoredUser();
      if (!OWNERS.has(String(current?.email || '').trim().toLowerCase()) || !current?.accessToken) {
        throw new Error('Sign in with your inventory owner account.');
      }
      return current.accessToken;
    },
  }), []);

  if (!user?.accessToken) return <Navigate to="/login" replace />;
  if (!OWNERS.has(email)) return <p role="alert">Inventory access is restricted to the owners for now.</p>;
  return <SlabInventory key={email} api={api} initialUseFilter={requestedUse} />;
}
